<template lang="pug">
div
  h4 Invoice data
  table.ui-app-data-table
    tbody
      tr(
        v-for="(item, field) in data"
        :key="field"
      )
        td(v-if="field !== 'InvoiceLines'") {{ field }}
        td(v-if="field !== 'InvoiceLines'") {{ item }}
  br
  h4 Invoice Lines
  LineItemsTable(:line_items="line_items")
</template>

<script>
import LineItemsTable from "@/views/PurchaseInvoice/components/line_items.vue";

export default {
  props: ["data", "line_items"],

  components: {
    LineItemsTable,
  },
};
</script>
